import React from "react";
import LoadingMark from "./LoadingMark";

const LoadingOverlay = ({ message }) => {
  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <LoadingMark size="md" message={message} />
    </div>
  );
};

export default LoadingOverlay;
